export const default_list = {
  "q-01": { value: 0 },
  "q-02": { value: 0 },
  "q-03": { value: 0 },
  "q-04": { value: 0 },
  "q-05": { value: 0 },
  "q-06": { value: 0 },
  "q-07": { value: 0 },
  "q-08": { value: 0 },
  "q-09": { value: 0 },
  "q-10": { value: 0 },
  "q-11": { value: 0 },
  "q-12": { value: 0 },
  "q-13": { value: 0 },
  "q-14": { value: 0 },
  "q-15": { value: 0 },
  "q-16": { value: 0 },
  "q-17": { value: 0 },
  "q-18": { value: 0 },
  "q-19": { value: 0 },
  "q-20": { value: 0 },
  "q-21": { value: 0 },
  "q-22": { value: 0 },
  "q-23": { value: 0 },
  "q-24": { value: 0 },
  "q-25": { value: 0 },
  "q-26": { value: 0 },
  "q-27": { value: 0 },
  "q-28": { value: 0 },
  "q-29": { value: 0 },
  "q-30": { value: 0 },
  "q-31": { value: 0 },
  "q-32": { value: 0 },
  "q-33": { value: 0 },
  "q-34": { value: 0 },
  "q-35": { value: 0 },
  "q-36": { value: 0 },
  "q-37": { value: 0 },
  "q-38": { value: 0 },
  "q-39": { value: 0 },
  "q-40": { value: 0 },
  "q-41": { value: 0 },
  "q-42": { value: 0 },
  "q-43": { value: 0 },
  "q-44": { value: 0 },
  "q-45": { value: 0 },
  "q-46": { value: 0 },
  "q-47": { value: 0 },
  "q-48": { value: 0 },
  "q-49": { value: 0 },
  "q-50": { value: 0 },
  "q-51": { value: 0 },
  "q-52": { value: 0 },
  "q-53": { value: 0 },
  "q-54": { value: 0 },
  "q-55": { value: 0 },
  "q-56": { value: 0 },
  "q-57": { value: 0 },
  "q-58": { value: 0 },
  "q-59": { value: 0 },
  "q-60": { value: 0 },
  "q-61": { value: 0 },
  "q-62": { value: 0 },
  "q-63": { value: 0 },
  "q-64": { value: 0 },
  "q-65": { value: 0 },
  "q-66": { value: 0 },
  "q-67": { value: 0 },
  "q-68": { value: 0 },
  "q-69": { value: 0 },
  "q-70": { value: 0 },
  "q-71": { value: 0 }
};

export const profile_list = {
  "q-01": { value: 0 },
  "q-02": { value: 0 },
  "q-03": { value: 0 },
  "q-04": { value: 0 },
  "q-05": { value: 0 },
  "q-06": { value: 0 },
  "q-07": { value: 0 },
  "q-08": { value: 0 },
  "q-09": { value: 0 },
  "q-10": { value: 0 },
  "q-11": { value: 0 },
  "q-12": { value: 0 }
};

export const twentyfivesections_list = {
  "q-01": { value: 0 },
  "q-02": { value: 0 },
  "q-03": { value: 0 },
  "q-04": { value: 0 },
  "q-05": { value: 0 },
  "q-06": { value: 0 },
  "q-07": { value: 0 },
  "q-08": { value: 0 },
  "q-09": { value: 0 },
  "q-10": { value: 0 },
  "q-11": { value: 0 },
  "q-12": { value: 0 },
  "q-13": { value: 0 },
  "q-14": { value: 0 },
  "q-15": { value: 0 },
  "q-16": { value: 0 },
  "q-17": { value: 0 },
  "q-18": { value: 0 },
  "q-19": { value: 0 },
  "q-20": { value: 0 },
  "q-21": { value: 0 },
  "q-22": { value: 0 },
  "q-24": { value: 0 },
  "q-25": { value: 0 }
};

export const twelvesections_list = {
  "q-01": { value: 0, notAnswered: true },
  "q-02": { value: 0, notAnswered: true },
  "q-03": { value: 0, notAnswered: true },
  "q-04": { value: 0, notAnswered: true },
  "q-05": { value: 0, notAnswered: true },
  "q-06": { value: 0, notAnswered: true },
  "q-07": { value: 0, notAnswered: true },
  "q-08": { value: 0, notAnswered: true },
  "q-09": { value: 0, notAnswered: true },
  "q-10": { value: 0, notAnswered: true },
  "q-11": { value: 0, notAnswered: true },
  "q-12": { value: 0, notAnswered: true },
  "q-13": { value: 0, notAnswered: true },
  "q-14": { value: 0, notAnswered: true },
  "q-15": { value: 0, notAnswered: true },
  "q-16": { value: 0, notAnswered: true },
  "q-17": { value: 0, notAnswered: true },
  "q-18": { value: 0, notAnswered: true },
  "q-19": { value: 0, notAnswered: true },
  "q-20": { value: 0, notAnswered: true },
  "q-21": { value: 0, notAnswered: true },
  "q-22": { value: 0, notAnswered: true },
  "q-23": { value: 0, notAnswered: true },
  "q-24": { value: 0, notAnswered: true },
  "q-25": { value: 0, notAnswered: true },
  "q-26": { value: 0, notAnswered: true },
  "q-27": { value: 0, notAnswered: true },
  "q-28": { value: 0, notAnswered: true },
  "q-29": { value: 0, notAnswered: true },
  "q-30": { value: 0, notAnswered: true },
  "q-31": { value: 0, notAnswered: true },
  "q-32": { value: 0, notAnswered: true },
  "q-33": { value: 0, notAnswered: true },
  "q-34": { value: 0, notAnswered: true },
  "q-35": { value: 0, notAnswered: true },
  "q-36": { value: 0, notAnswered: true },
  "q-37": { value: 0, notAnswered: true },
  "q-38": { value: 0, notAnswered: true },
  "q-39": { value: 0, notAnswered: true },
  "q-40": { value: 0, notAnswered: true },
  "q-41": { value: 0, notAnswered: true },
  "q-42": { value: 0, notAnswered: true },
  "q-43": { value: 0, notAnswered: true },
  "q-44": { value: 0, notAnswered: true },
  "q-45": { value: 0, notAnswered: true },
  "q-46": { value: 0, notAnswered: true },
  "q-47": { value: 0, notAnswered: true },
  "q-48": { value: 0, notAnswered: true },
  "q-49": { value: 0, notAnswered: true },
  "q-50": { value: 0, notAnswered: true },
  "q-51": { value: 0, notAnswered: true },
  "q-52": { value: 0, notAnswered: true },
  "q-53": { value: 0, notAnswered: true },
  "q-54": { value: 0, notAnswered: true },
  "q-55": { value: 0, notAnswered: true },
  "q-56": { value: 0, notAnswered: true },
  "q-57": { value: 0, notAnswered: true },
  "q-58": { value: 0, notAnswered: true },
  "q-59": { value: 0, notAnswered: true },
  "q-60": { value: 0, notAnswered: true }
};



// WEBPACK FOOTER //
// ./src/modules/evaluation/questionList.js